module.exports = __webpack_public_path__ + "img/图1-16对称图形的尺寸注法.4c0a2a37.jpg";